import { cn } from '@/lib/utils';
import { Skeleton } from '../Skeleton';
import { ShapeGroup } from './ShapeGroup';

interface MatchCardsSkeletonProps {
  count?: number;
  label?: string;
  className?: string;
}

/** The compact stacked match cards of the mobile lists: opponent over date, result at the end. */
export function MatchCardsSkeleton({ count = 3, label, className }: MatchCardsSkeletonProps) {
  return (
    <ShapeGroup label={label} className={cn('space-y-1.5', className)}>
      {Array.from({ length: count }, (_, i) => (
        <div
          key={i}
          data-skeleton-card=""
          className="border-border bg-card flex items-center justify-between gap-3 rounded-lg border p-3"
        >
          <div className="min-w-0 flex-1 space-y-2">
            <Skeleton.Line width="50%" className="h-4" />
            <Skeleton.Line width="30%" />
          </div>
          <Skeleton.Pill />
        </div>
      ))}
    </ShapeGroup>
  );
}
